<template lang="pug">
  div.exchange
    van-form
        van-field(class="bind_form", v-model="code", :placeholder="$t('inputExCode')")
        van-button(class="bind_btn", native-type="submit", type="danger", block, round, @click="onSubmit", :disabled='isDisabled') {{$t('receive')}}
        van-popup(v-model="rolePop", closeable, round, close-icon="close")
          van-form(@submit="submitCode")
            van-field(v-if="isArea", :value="area", readonly, :placeholder="this.$t('selectRecion')", @click="showArea=true")
            van-field(:value="server", readonly, :placeholder="this.$t('selectService')", @click="showServer=true")
            van-field(:value="role", readonly, :placeholder="this.$t('selectRoll')", @click="showRole=true")
            van-button(type="danger", round, class="pay_btn") {{$t('receive')}}
        van-popup(v-model="showArea", position="bottom")
          van-picker(show-toolbar, :columns="areaColumns", @confirm="areaConfirm", @cancel="showArea=false", :confirm-button-text="sure", :cancel-button-text="back")
        van-popup(v-model="showServer", position="bottom")
          van-picker(show-toolbar, :columns="serverColumns", @confirm="serverConfirm", @cancel="showServer=false", :confirm-button-text="sure", :cancel-button-text="back")
        van-popup(v-model="showRole", position="bottom")
          van-picker(show-toolbar, :columns="roleColumns", @confirm="roleConfirm", @cancel="showRole=false", :confirm-button-text="sure", :cancel-button-text="back")
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Exchange',
  data($vm){
    return{
      code: '',
      isDisabled: false,
      disabled: false,
      rolePop: false,
      area: '',
      areaId: '',
      server: '',
      serverId: '',
      role: '',
      roleId: '',
      sendCode: $vm.$t('sendCode'),
      showArea: false,
      showServer: false,
      showRole: false,
      areaColumns: [],
      serverColumns: [],
      roleColumns: [],
      isArea: true
    }
  },
  created(){
    this.getAreaList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
    })
  },
  methods:{
    ...mapActions(['getUserInfo', 'getAreaList', 'getServerList', 'getGameRoleList']),
    ...mapActions('activation', ['exchange']),
    onSubmit(){
      if(this.code){
        this.rolePop = true;
      }
    },
    submitCode(){
      this.exchange(Qs.stringify({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        code: this.code,
        areaId: this.areaId,
        serverId: this.serverId,
        roleId: this.roleId
      }))
    },
    areaConfirm(val){
      this.area = val
      this.showArea = false
      this.areaList.areaInfoList.map(v => {
        if(v.areaName === val){
          this.areaId =  v.id
        }
      })
      this.getServerList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        areaId: this.areaId
      })
    },
    serverConfirm(val){
      this.server = val
      this.showServer = false
      this.serverList.serverList.map(v => {
        if(v.serverName === val){
          this.serverId = v.serverId
        }
      })
      if(this.areaColumns.length < 2){
        this.getGameRoleList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          cpUid: this.cpUid,
          areaId: this.areaList.areaInfoList[0].id,
          serverId: this.serverId
        })
      } else {
        this.getGameRoleList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          cpUid: this.cpUid,
          areaId: this.areaId,
          serverId: this.serverId
        })
      }
    },
    roleConfirm(val){
      this.role = val
      this.showRole = false
      this.roleList.gameRoleList.map(v => {
        if(v.roleName === val){
          this.roleId = v.roleId
        }
      })
    }
  },
  computed:{
      ...mapGetters(['loading', 'cpUid', 'uid', 'deviceId', 'token', 'appid', 'serverList', 'loadingSL', 'roleList', 'loadingRL', 'areaList', 'loadingAL']),
      ...mapGetters('activation', ['exchangeData', 'exStatus']),
      sure: $vm => {
        return $vm.$t('sure')
      },
      back: $vm => {
        return $vm.$t('return')
      },
  },
  mounted(){
    this.$watch('exStatus', val => {
        if(val === 'exStatused'){
          if(this.exchangeData === 'success'){
          this.rolePop = false
            Toast.success(this.$t('getOk'));
          }
        }
    })
    this.$watch('loadingAL', val => {
      if(val === 'loadedAL'){
        this.areaColumns = this.areaList.areaInfoList.map(val => {
          return val.areaName
        })
        if(this.areaColumns.length < 2){
          this.isArea = false
          this.areaId = this.areaList.areaInfoList[0].id
          this.getServerList({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token,
            areaId: this.areaList.areaInfoList[0].id
          })
        }
      }
    })
    this.$watch('loadingSL', val => {
      if(val === 'loadedSL'){
        this.serverColumns = this.serverList.serverList.map(val => {
          return val.serverName
        })
        if(this.areaColumns.length > 1){
          this.showServer = true
        }
      }
    })
    this.$watch('loadingRL', val => {
      if(val === 'loadedRL'){
        this.roleColumns = this.roleList.gameRoleList.map(val => {
          return val.roleName
        })
        this.showRole = true
      }
    })
  }
}
</script>
<style lang="scss">
.exchange{
  margin: 20px;
  .bind_form{
    margin-top: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 2px #ebebeb;
  }
  .bind_code{
    margin-top: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 2px #ebebeb;
  }
  .bind_btn{
      margin-top: 20px;
      width: 90%;
      left: 5%;
      padding: 15px;
  }
  .van-popup--center.van-popup--round{
    border-radius: 10px;
  }
  .van-popup--center{
    width: 70%;
    .van-form{
      margin: 20px 25px;
    }
  }
  .van-icon-close{
    margin-top: -15px;
    margin: -15px;
  }
  .van-field__body{
    &::after {
      position: absolute;
      top: 50%;
      right: -4px;
      margin-top: -5px;
      border: 3px solid;
      border-color: transparent transparent #dcdee0 #dcdee0;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      opacity: 0.8;
      content: '';
    }
  }
  .van-cell{
    border: 1px solid #ebebeb;
    margin-bottom: 10px;
    padding: 5px 10px;
    &::after{
      border: 0px;
    }
  }
  .pay_btn{
    width: 100%;
    left: 0;
    padding: 15px;
  }
}
</style>